// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2t-1";
export var movingGradient = "_2t-4";
export var movingGradientBlock = "_2t-2";
export var skeleton = "_2t-0";
export var skeletonText = "_2t-3";